<template>
  <div class="mobile-page" @touchmove="handleTouchMove">
    <div class="mobile-list">
      <template v-for="(item, index) in list">
        <div class="mobile-list-item mobile-zi-ji" :key="index" v-if="item.role == 'user'">
          <img class="mobile-list-item-jiao" src="@/assets/images/mobile-image.png" />
          <div class="mobile-item-text">
            <img class="mobile-value-text-icon" src="@/assets/images/kongjian-details-wechat-icon.png" />
            <div class="mobile-value-text">
              {{ item.content }}
            </div>
          </div>
        </div>
        <div class="mobile-list-item" :key="index" v-else>
          <img class="mobile-list-item-jiao" :src="query.userImage" />
          <div class="mobile-item-text">
            <img class="mobile-value-text-icon" src="@/assets/images/kongjian-details-wechat-icon-zj.png" />
            <div class="mobile-value-text">
              <!-- <img
              class="yuyico"
              v-if="audioURL==item.replyAudioUrl"
              src="@/assets/images/audio-play.gif"
              />
              <img
              v-else
              class="yuyico"
              src="@/assets/images/audio-play-default.png"
              /> -->

              <div>{{ item.content }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-if="isSendLoading" class="mobile-cancel-loading ">
      <div class="el-icon-loading"></div>
    </div>
    <div class="mobile-cancel" v-if="isTap">
      <div v-if="startTouch.clientY - endTouch.clientY > 30">
        <img src="@/assets/images/返回.png" alt="" class="mobile-cancel-img" />
        <div class="mobile-cancel-desc">松开手指，取消发送</div>
      </div>
      <div v-else>
        <img src="@/assets/images/audio-playing.gif" alt="" class="mobile-cancel-audio" />
        <div class="mobile-cancel-desc">手指上划，取消发送</div>
      </div>
    </div>
    <div class="mobile-tools">
      <template v-if="showText">
        <img class="mobile-tools-icon" src="@/assets/images/文字.png" alt="" @click="changgeshow" />
        <el-input type="textarea" autosize class="mobile-tools-input" placeholder="你可以使用输入法录音快速输入..." v-model="xiaoxi"
          autofocus ref="textarea" />
        <div class="mobile-tools-send" @click.stop="send">发送</div>
      </template>
      <template v-else>
        <img class="mobile-tools-icon" src="@/assets/images/语音.png" alt="" @click="showText = !showText" />
        <div @touchstart="startRecording" @touchend="stopRecording" class="mobile-tools-desc"
          :class="{ 'mobile-tools-desc-tap': isTap }">
          <div v-if="!isTap">按住说话</div>
          <div v-else>
            松开发送
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { getDialogueList, inputPost, audioPost } from "@/api/go";
import { v4 as uuidv4 } from "uuid";
import Recorder from "recorder-core/recorder.mp3.min";
// import VConsole from "vconsole";

export default {
  name: "",
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      query: {
        // id
        id: ""
      },
      isTap: false,
      recordingTime: 0,
      mediaRecorder: null,
      startTouch: {},
      endTouch: {},
      timer: null,
      xiaoxi: "",
      showText: true,
      list: [],
      audioURL: "",
      isSendLoading: false,
      permitRecording: false
    };
  },
  methods: {
    async changgeshow() {
      let that = this
      // that.recOpen(() => {
      //   that.showText = !that.showText
      // });

      that.showText = !that.showText

    },
    recOpen(success) {
      //一般在显示出录音按钮或相关的录音界面时进行此方法调用，后面用户点击开始录音时就能畅通无阻了
      this.mediaRecorder = Recorder({
        //本配置参数请参考下面的文档，有详细介绍
        type: "mp3",
        sampleRate: 16000,
        bitRate: 16, //mp3格式，指定采样率hz、比特率kbps，其他参数使用默认配置；注意：是数字的参数必须提供数字，不要用字符串；需要使用的type类型，需提前把格式支持文件加载进来，比如使用wav格式需要提前加载wav.js编码引擎
        onProcess: function (
          buffers,
          powerLevel,
          bufferDuration,
          bufferSampleRate,
          newBufferIdx,
          asyncEnd
        ) {
          //录音实时回调，大约1秒调用12次本回调，buffers为开始到现在的所有录音pcm数据块(16位小端LE)
          //可利用extensions/sonic.js插件实时变速变调，此插件计算量巨大，onProcess需要返回true开启异步模式
          //可实时上传（发送）数据，配合Recorder.SampleData方法，将buffers中的新数据连续的转换成pcm上传，或使用mock方法将新数据连续的转码成其他格式上传，可以参考文档里面的：Demo片段列表 -> 实时转码并上传-通用版；基于本功能可以做到：实时转发数据、实时保存数据、实时语音识别（ASR）等
        }
      });

      this.mediaRecorder.open(
        () => {
          //打开麦克风授权获得相关资源
          //rec.start() 此处可以立即开始录音，但不建议这样编写，因为open是一个延迟漫长的操作，通过两次用户操作来分别调用open和start是推荐的最佳流程
          success && success();
        },
        (msg, isUserNotAllow) => {
          //用户拒绝未授权或不支持
          this.$message({
            customClass: "mobile-message",
            message:
              (isUserNotAllow ? "UserNotAllow，" : "") + "无法录音:" + msg,
            type: "warning"
          });
          this.mediaRecorder = null;
        }
      );
    },
    /**开始录音**/
    recStart() {
      //打开了录音后才能进行start、stop调用
      this.mediaRecorder.start();
    },
    /**结束录音**/
    recStop(success) {
      this.mediaRecorder.stop(
        (blob, duration) => {
          //简单利用URL生成本地文件地址，注意不用了时需要revokeObjectURL，否则霸占内存
          //此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          var localUrl = (window.URL || webkitURL).createObjectURL(blob);
          console.log(blob, localUrl, "时长:" + duration + "ms");
          this.mediaRecorder.close(); //释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
          this.mediaRecorder = null;
          success && success(blob, duration);
          //已经拿到blob文件对象想干嘛就干嘛：立即播放、上传、下载保存
        },
        msg => {
          console.log("录音失败:" + msg);
          this.mediaRecorder.close(); //可以通过stop方法的第3个参数来自动调用close
          this.mediaRecorder = null;
        }
      );
    },
    startRecording(endEvent) {
      let that = this
      endEvent.preventDefault();
      that.recOpen(() => {
        // 防止第一次弹出授权框执行
        if (that.permitRecording) {
          that.isTap = true;
          const secondFinger = endEvent.touches[0];
          that.endTouch = {};
          that.startTouch = secondFinger;
          that.recordingTime = Date.now();
          console.log("Recording started");
          that.recStart();
        } else {
          that.permitRecording = true
        }

      });

    },
    handleTouchMove(endEvent) {
      if (this.isTap) {
        this.endTouch = endEvent.touches[0];
      }
    },
    stopRecording() {
      let that = this
      // 加延时防止误点击导致录音动效无法取消
      // setTimeout(() => {
      //   that.isTap = false;
      // }, 500);
      that.isTap = false;
      if (this.mediaRecorder) {
        this.recStop((blob, duration) => {
          // setTimeout(() => {
          //   that.isTap = false;
          // }, 200);
          let time = Date.now() - this.recordingTime;
          if (time < 500) {
            this.$message({
              customClass: "mobile-message",
              message: "录音时间太短",
              type: "warning"
            });
          } else if (this.startTouch.clientY - this.endTouch.clientY > 30) {
            // this.$message({
            //   customClass: "mobile-message",
            //   message: "录音已取消",
            //   type: "warning"
            // });
          } else {
            console.log("Recording stopped");
            this.isSendLoading = true;
            let file = new File([blob], `audio.mp3`, {
              type: blob.type,
              lastModified: Date.now()
            });
            console.log(file);
            audioPost(
              `?userId=${this.query.id}&type=${this.query.type
              }&sessionId=${this.getBrowserFingerprint() +
              "-" +
              this.query.id}`,
              {
                file: file
              }
            )
              .then(() => {
                this.initList();
                this.isSendLoading = false;
              })
              .catch(() => {
                this.isSendLoading = false;
              });
          }
          this.endTouch = {};
          this.startTouch = {};
        });
      }
    },
    getDialogueList() {
      let that = this
      return getDialogueList({
        userId: this.query.id,
        sessionId: this.getBrowserFingerprint() + "-" + this.query.id,
        type: this.query.type // 1 视频、2 语音
      }).then(res => {
        this.list = this.list.concat(res || []);
        this.$nextTick(() => {
          // 滚动到底部
          that.scrollToBottom();
        });
      });
    },
    scrollToBottom() {
      // 获取 class="mobile-list" 的元素
      const mobileList = document.querySelector('.mobile-list');
      // 滚动到最底部
      mobileList.scrollTop = mobileList.scrollHeight;
    },

    getBrowserFingerprint() {
      let zw = localStorage.getItem("fingerprint");
      if (zw) {
        return zw;
      } else {
        zw = uuidv4();
        localStorage.setItem("fingerprint", zw);
        return zw;
      }
    },
    send() {
      // this.$refs.textarea.focus();
      if (!this.xiaoxi) {
        this.$message({
          customClass: "mobile-message",
          message: "对话内容不能为空",
          type: "warning"
        });
        return false;
      }
      inputPost(
        `?userId=${this.query.id}&type=${this.query.type
        }&sessionId=${this.getBrowserFingerprint() + "-" + this.query.id}`,
        {
          content: this.xiaoxi
        }
      )
        .then(res => {
          this.xiaoxi = "";
          this.initList();
        })
        .catch(res => {
          this.$message({
            customClass: "mobile-message",
            message: "发送失败",
            type: "warning"
          });
        });
    },
    initList() {
      this.getDialogueList();
      if (window.timer) {
        clearInterval(window.timer);
      }
      window.timer = setInterval(() => {
        this.getDialogueList();
      }, 4000);
    }
  },
  created() {
    this.$route.query.userImage = decodeURIComponent(
      this.$route.query.userImage
    );
    this.query = this.$route.query;
    if (this.query.id) {
      this.initList();
    }
    // this.vConsole = new VConsole();
  },
  mounted() {
    // this.recOpen(() => {
    //   this.mediaRecorder.start();
    //   setTimeout(() => {
    //     this.mediaRecorder.stop();
    //   }, 200);
    // });
  },
  beforeDestroy() {
    if (window.timer) {
      clearInterval(window.timer);
    }

    // this.vConsole.destroy();
  }
};
</script>

<style lang="scss" scoped>
.mobile-page {
  overflow: hidden;
  background: url(~@/assets/images/背景.png);
  background-size: 101% 100%;
  width: calc(100vw + 0px);
  height: calc(100vh + 0px);
}

.mobile-list {
  padding: 0 16px;
  margin-top: 36px;
  height: calc(100vh - 36px - 76px);
  overflow-y: auto;
}

.mobile-list-item {
  line-height: 22px;

  display: flex;
  align-content: flex-start;

  &+.mobile-list-item {
    margin-top: 24px;
  }

  .mobile-list-item-jiao {
    border-radius: 50%;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
  }

  .mobile-item-text {
    position: relative;
    margin-left: 10px;
    margin-right: 10px;
    background: #fff;
    max-width: calc(100% - 48px - 48px);
    text-align: left;
    border-radius: 6px;
  }

  .mobile-value-text {
    padding: 12px 13px;
    color: #333333;
    font-size: 15px;
    line-height: 24px;
  }

  .mobile-value-text-icon {
    width: 4px;
    height: 7px;
    top: 20px;
    position: absolute;
    left: -3px;
  }
}

.mobile-zi-ji {
  flex-flow: row-reverse;

  .mobile-item-text {
    background-color: rgb(27, 186, 133);
    color: rgb(255, 255, 255);
  }

  .mobile-value-text-icon {
    left: auto;
    right: -3px;
    transform: rotate(180deg);
  }
}

.mobile-tools {
  position: fixed;
  bottom: 16px;
  left: 20px;
  right: 20px;
  display: flex;

  .mobile-tools-icon {
    width: 40px;
    height: 40px;
    margin-right: 9px;
    flex-shrink: 0;
  }

  .mobile-tools-input {
    flex: 1;
    border-radius: 10px;
    background: #ffffff;
    text-align: left;
    color: #000000;
    font-size: 14px;
    padding: 7px 10px;
    border: none;
    resize: none;
    box-shadow: 1px -1px 3px 1px rgba(158, 158, 158, 0.2);

    &::v-deep {
      .el-textarea__inner {
        border: none;
        max-height: 100px;
        line-height: 27px;
        height: 28px !important;
        white-space: nowrap;
        /* 禁止换行 */
        overflow: hidden;
        /* 隐藏超出部分 */
        text-overflow: ellipsis;
        /* 超出部分显示省略号 */
      }
    }
  }

  .mobile-tools-send {
    flex-shrink: 0;
    margin-left: 10px;
    border-radius: 4px;
    width: 56px;
    height: 34px;
    line-height: 34px;
    background: #29ad68;
    color: #fff;
    text-align: center;
    margin-top: 4px;
    font-size: 16px;
  }

  .mobile-tools-desc {
    flex: 1;
    border-radius: 10px;
    background: #ffffff;
    text-align: center;
    color: #000000;
    font-size: 16px;
    padding: 12px 10px 9px 10px;
    -webkit-user-select: none;
    /* Safari */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE10+/Edge */
    user-select: none;
    /* 标准语法 */
  }

  .mobile-tools-desc-tap {
    background: #d8d8d8;
  }
}

.mobile-cancel {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 158px;
  transform: translate(-50%, -50%);
  background: #000000;
  text-align: center;
  padding: 15px 11px;
  border-radius: 8px;
  overflow: hidden;

  .mobile-cancel-audio {
    filter: brightness(10);
    width: 136px;
    margin-top: -10px;
    margin-bottom: -20px;
  }

  .mobile-cancel-img {
    margin-top: 30px;
    margin-bottom: 28px;
  }

  .mobile-cancel-desc {
    font-size: 13px;
    font-weight: normal;
    line-height: 14px;
    color: #9e9e9e;
  }
}

.yuyico {
  width: 100px;
  height: 140px;
}
</style>
